<template>
	<div>
		<div class="d-flex justify-space-between">
			<h2 class="mb-4">Transition Library</h2>
			<v-btn color="primary" @click="showAdd()">Add Transition</v-btn>
		</div>

		<v-row>
			<v-col cols="3">
				<v-autocomplete
					v-model="planFilter"
					chips
					small-chips
					deletable-chips
					label="Filter by plans"
					multiple
					:items="tenantPlanList"
					item-value="id"
					:item-text="(item) => item.name + ' - ' + item.type"
					solo
					dense
				></v-autocomplete>
			</v-col>
			<v-col cols="3">
				<v-autocomplete
					v-model="tagFilter"
					:items="tagList"
					chips
					small-chips
					deletable-chips
					label="Filter by tags"
					multiple
					solo
					dense
				></v-autocomplete>
			</v-col>
			<div style="display: flex; flex-direction: row; margin-top: 13px">
				<v-btn color="primary" style="margin-right: 10px" @click="filterLibrary">filter</v-btn>
				<v-btn color="primary" @click="resetFilter">Reset</v-btn>
			</div>
		</v-row>

		<div class="d-flex flex-wrap justify-space-around align-stretch">
			<v-hover v-for="(entity, index) in transitionLibraryList" :key="index" v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" width="340" class="mb-5">
					<v-card-title>
						<span>{{ entity.name }}</span>
						<v-spacer></v-spacer>
					</v-card-title>
					<div id="structure-view" style="display: block">
						<div class="entry-view">
							<v-img
								v-if="entity.backgroundTransitionDisplay"
								:src="$root.asset(entity.backgroundTransitionDisplay)"
								max-height="200"
								min-height="200"
							></v-img>
							<v-img
								v-else-if="$root.isImage(entity.backgroundTransition)"
								:src="$root.asset(entity.backgroundTransition)"
								max-height="200"
								min-height="200"
							></v-img>
							<video
								v-else-if="$root.isVideo(entity.backgroundTransition)"
								width="100%"
								style="max-height: 200px; min-height: 200px"
								preload="auto"
								autoplay="autoplay"
								muted
								playsinline
								disablepictureinpicture
								loop="loop"
							>
								<source :src="$root.asset(entity.backgroundTransition)" type="video/mp4" />
							</video>
							<template v-else-if="$root.isYoutubeUrl(entity.backgroundTransition)">
								<youtube
									:videoId="$root.getYoutubeId(entity.backgroundTransition, backgroundYoutubeParams)"
									:player-vars="$root.getYoutubeParams(entity.backgroundTransition)"
									style="pointer-events: none "
									width="340"
									height="200"
									ref="backgroundIndexYoutube"
								></youtube>
							</template>
							<vimeo-player
								v-else-if="$root.isVimeoUrl(entity.backgroundTransition)"
								:video-url="entity.backgroundTransition"
								:options="backgroundVimeoParams"
								style="pointer-events: none"
								player-width="340"
								player-height="200"
							></vimeo-player>
						</div>
					</div>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="showEdit(entity)">
									<v-icon>mdi-pencil</v-icon>
								</v-btn>
							</template>
							<span>Edit Transition</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="deleteTransitionLibrary(entity.id)">
									<v-icon color="red">mdi-delete</v-icon>
								</v-btn>
							</template>
							<span>Delete Transition</span>
						</v-tooltip>
					</v-card-actions>
				</v-card>
			</v-hover>
		</div>

		<v-dialog v-model="dialogAdd" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card>
				<v-card-title class="headline">
					Add Transition Library
					<v-spacer></v-spacer>
					<v-btn icon @click="closeAdd()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-row class="d-flex justify-center">
						<v-col cols="7">
							<v-form ref="formAdd" v-model="valid" @submit.prevent="addTransitionLibrary">
								<div id="structure-view" style="display: block" class="mb-5">
									<v-row class="entry-view">
										<v-col ref="box" id="box">
											<video
												v-if="
													backgroundTransitionTemp &&
													backgroundTransitionTemp.startsWith('data') &&
													backgroundTransitionName.toLowerCase().endsWith('.mp4')
												"
												width="100%"
												height="550px"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source :src="backgroundTransitionTemp" type="video/mp4" />
											</video>
											<video
												v-else-if="entity.backgroundTransition && $root.isVideo(entity.backgroundTransition)"
												width="100%"
												height="550px"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source
													:src="
														entity.backgroundTransition.toLowerCase().startsWith('http')
															? entity.backgroundTransition
															: baseLocation + '/asset/file/' + entity.backgroundTransition
													"
													type="video/mp4"
												/>
											</video>
											<div v-else-if="entity.backgroundTransition && backgroundTransitionType == 'URL' && $root.isYoutubeUrl(entity.backgroundTransition)">
												<youtube
													:videoId="$root.getYoutubeId(entity.backgroundTransition, backgroundYoutubeParams)"
													:player-vars="backgroundYoutubeParams"
													style="pointer-events: none "
													width="1000"
													height="550"
												></youtube>
											</div>
											<vimeo-player 
												v-else-if="entity.backgroundTransition && backgroundTransitionType == 'URL'  && $root.isVimeoUrl(entity.backgroundTransition)"
												:video-url="entity.backgroundTransition"
												:options="backgroundVimeoParams"
												style="pointer-events: none "
												player-width="1000"
												player-height="550"
												ref="background"
											></vimeo-player>
											<div v-else style="border: 5px solid black; width: 100%; height: 550px"></div>
											<!--- INPUT BACKGROUND-->
											<v-row>
												<v-col cols="12" sm="3">
													<v-select v-model="backgroundTransitionType" :items="['Upload', 'URL']" label="Background Type"></v-select>
												</v-col>
												<v-col cols="12" sm="9" v-if="backgroundTransitionType === 'Upload'">
													<input
														ref="attachment1"
														type="file"
														accept="video/mp4"
														@change="onBackgroundUpload"
														style="display: none"
													/>
													<v-text-field
														v-model="backgroundTransitionFileName"
														label="Transition Video"
														hint="It’s recommended to use video with resolution of 1080 pixels."
														placeholder="Upload Transition Video"
														prepend-icon="mdi-image-move"
														@click="openBackgroundDialog()"
														readonly
														:rules="[(v) => !!v || 'Transition video is required']"
													>
													</v-text-field>
												</v-col>
												<v-col cols="12" sm="9" v-else>
													<v-text-field
														v-model="entity.backgroundTransition"
														prepend-icon="mdi-image"
														label="Background"
														placeholder="Background Url"
														hint="Please input image url with jpeg/jpg/png extension"
														:rules="[(v) => !!v || 'Transition image is required']"
													></v-text-field> </v-col
											></v-row>
											<!-- END OF INPUT BACKGROUND-->
										</v-col>
									</v-row>
								</div>
								<v-row>
									<v-col cols="12">
										<v-text-field
											v-model="entity.name"
											label="Name"
											:rules="[(v) => !!v || 'Name is required']"
											@input="entity.slug = entity.name ? entity.name.toLowerCase().replace(' ', '') : null"
											prepend-icon="mdi-home"
											dense
										></v-text-field>
									</v-col>
									<v-col cols="12">
										<v-combobox
											v-model="entity.tagList"
											:items="tagList"
											label="Select a tag or create a new one"
											multiple
											small-chips
											deletable-chips
										></v-combobox>
									</v-col>
									<v-col cols="12">
										<v-checkbox v-model="isTargetOne" label="This library only for 1 tenant"></v-checkbox>
									</v-col>
									<v-col cols="12" v-if="isTargetOne">
										<v-autocomplete
											v-model="entity.targetId"
											label="Tenant"
											:rules="[(v) => !!v || 'This field is required']"
											:items="tenantList"
											item-text="name"
											item-value="id"
										>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" v-if="!isTargetOne">
										<v-select
											v-model="entity.planList"
											label="Membership Plan"
											:rules="[(v) => !!v.length > 0 || 'This field is required']"
											multiple
											chips
											:items="tenantPlanList"
											item-value="id"
											:item-text="(item) => item.name + ' - ' + item.type"
										>
											<template v-slot:selection="{ item }" :default="entity.planList">
												<v-chip color="primary" dark small> {{ item.name }} - {{ item.type }}</v-chip>
											</template>
										</v-select>
									</v-col>
								</v-row>
								<div class="d-flex justify-end">
									<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
								</div>
							</v-form>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogEdit" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card>
				<v-card-title class="headline">
					Edit Transition Library
					<v-spacer></v-spacer>
					<v-btn icon @click="closeEdit()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-row class="d-flex justify-center">
						<v-col cols="7">
							<v-form ref="formEdit" v-model="validEdit" @submit.prevent="editTransitionLibrary">
								<div id="structure-view" style="display: block" class="mb-5">
									<v-row class="entry-view">
										<v-col ref="box" id="box">
											<video
												v-if="
													editBackgroundTransitionTemp &&
													editBackgroundTransitionTemp.startsWith('data') &&
													backgroundTransitionName.toLowerCase().endsWith('.mp4')
												"
												width="100%"
												height="550px"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source :src="editBackgroundTransitionTemp" type="video/mp4" />
											</video>
											<div v-else-if="entityEdit.backgroundTransition && $root.isVideo(entityEdit.backgroundTransition)" class="d-flex justify-center">
												<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Background 
													&& (entityEdit.transitMap.videoUploadStatus.Background === 'ready' || entityEdit.transitMap.videoUploadStatus.Background === 'uploading')" 
													class="icon_vimeo_progress_upload">mdi-progress-upload
												</v-icon>
												<video
													width="100%"
													preload="auto"
													autoplay="autoplay"
													muted
													playsinline
													disablepictureinpicture
													loop="loop"
												>
													<source
														:src="
															entityEdit.backgroundTransition.toLowerCase().startsWith('http')
																? entityEdit.backgroundTransition
																: baseLocation + '/asset/file/' + entityEdit.backgroundTransition
														"
														type="video/mp4"
													/>
												</video>
											</div>
											<div v-else-if="entityEdit.backgroundTransition && backgroundTransitionType == 'URL' && $root.isYoutubeUrl(entityEdit.backgroundTransition)">
												<youtube
													:videoId="$root.getYoutubeId(entityEdit.backgroundTransition, backgroundYoutubeParams)"
													:player-vars="backgroundYoutubeParams"
													style="pointer-events: none "
													width="1000"
													height="550"
												></youtube>
											</div>
											<div v-else-if="entityEdit.backgroundTransition && backgroundTransitionType == 'URL'  && $root.isVimeoUrl(entityEdit.backgroundTransition)" class="d-flex justify-center">
												<v-icon v-if="entityEdit.transitMap && entityEdit.transitMap.videoUploadStatus && entityEdit.transitMap.videoUploadStatus.Background 
													&& entityEdit.transitMap.videoUploadStatus.Background === 'available'" 
													class="icon_vimeo_succes_upload" small>mdi-vimeo
												</v-icon>
												<vimeo-player 
													:video-url="entityEdit.backgroundTransition"
													:options="backgroundVimeoParams"
													style="pointer-events: none "
													player-width="1000"
													player-height="550"
													ref="background"
												></vimeo-player>
											</div>
											<div v-else style="border: 5px solid black; width: 100%; height: 350px"></div>
											<v-row>
												<v-col cols="12" sm="3">
													<v-select v-model="backgroundTransitionType" :items="['Upload', 'URL']" label="Background Type"></v-select>
												</v-col>
												<v-col cols="12" sm="9" v-if="backgroundTransitionType === 'Upload'">
													<input
														ref="attachment1"
														type="file"
														accept="image/png, image/jpeg, image/jpg, video/mp4"
														@change="onBackgroundUpload"
														style="display: none"
													/>
													<v-text-field
														v-model="backgroundTransitionFileName"
														label="Background"
														hint="It’s recommended to use image with resolution approximately 1920 x 1080 pixels and recommended size is under 2MB, and for video it's recommended to use resolution of 1080 pixels."
														placeholder="Upload Background"
														prepend-icon="mdi-image"
														@click="openBackgroundDialog()"
														readonly
														:rules="[(v) => !!v || 'Transition image is required']"
													>
													</v-text-field>
												</v-col>
												<v-col cols="12" sm="9" v-else>
													<v-text-field
														v-model="entityEdit.backgroundTransition"
														prepend-icon="mdi-image"
														label="Background"
														placeholder="Background Url"
														hint="Please input image url with jpeg/jpg/png extension"
														:rules="[(v) => !!v || 'Transition image is required']"
													></v-text-field> </v-col
											></v-row>
										</v-col>
									</v-row>
								</div>
								<v-row>
									<v-col cols="12">
										<v-text-field
											v-model="entityEdit.name"
											label="Name"
											:rules="[(v) => !!v || 'Name is required']"
											@input="entityEdit.slug = entityEdit.name ? entityEdit.name.toLowerCase().replace(' ', '') : null"
											prepend-icon="mdi-home"
											dense
										></v-text-field>
									</v-col>
									<v-col cols="12">
										<v-combobox
											v-model="entityEdit.tagList"
											:items="tagList"
											label="Select a tag or create a new one"
											multiple
											small-chips
											deletable-chips
										></v-combobox>
									</v-col>
									<v-col cols="12">
										<v-checkbox v-model="isTargetOne" label="This library only for 1 tenant"></v-checkbox>
									</v-col>
									<v-col cols="12" v-if="isTargetOne">
										<v-autocomplete
											v-model="entityEdit.targetId"
											label="Tenant"
											:rules="[(v) => !!v || 'This field is required']"
											:items="tenantList"
											item-text="name"
											item-value="id"
											v-if="isTargetOne"
										>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" v-if="!isTargetOne">
										<v-select
											v-model="entityEdit.planList"
											label="Membership Plan"
											:rules="[(v) => !!v.length > 0 || 'This field is required']"
											multiple
											chips
											:items="tenantPlanList"
											item-value="id"
											:item-text="(item) => item.name + ' - ' + item.type"
										>
											<template v-slot:selection="{ item }" :default="entityEdit.planList">
												<v-chip color="primary" dark small> {{ item.name }} - {{ item.type }}</v-chip>
											</template>
										</v-select>
									</v-col>
								</v-row>
								<div class="d-flex justify-end">
									<v-btn :disabled="!validEdit" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
								</div>
							</v-form>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<style scoped>
#structure-view .entry-view {
	max-width: 100%;
	margin: 0 auto;
}
.entry-view {
	position: relative;
}
.structure-link {
	cursor: pointer;
	position: absolute;
}
.longtext {
	max-width: 100px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.icon_vimeo_succes_upload {
	color: white; 
	background-color: rgb(38, 185, 241); 
	border-radius: 25px;
	width: 25px;
	height: 25px;
	padding-top: 4px;
	align-items: flex-start;
}
.icon_vimeo_progress_upload {
	color: #f00; 
	align-items: flex-start;
}
</style>

<script>
import axios from "axios";

export default {
	data() {
		return {
			valid: true,
			validEdit: true,
			dialogAdd: false,
			dialogEdit: false,
			transitionLibraryList: [],
			entity: { dataMap: {}, linkToDataList: [], planList: [] },
			entityEdit: { planList: [] },
			backgroundTransitionType: "Upload",
			attachment1: null,
			baseLocation: axios.defaults.baseURL,
			tenantPlanList: [],
			tenantList: [],
			backgroundTransitionFileName: "",
			backgroundTransitionName: "",
			editBackgroundTransitionTemp: "",
			backgroundTransitionTemp: "",
			isTargetOne: false,
			tagList: [],
			tagFilter: [],
			planFilter: [],
			transitionLibraryAll: [],
			backgroundYoutubeParams: { autoplay: 1, showinfo: 0, controls: 0, mute: 1, loop: 1, playlist: ''},
			backgroundVimeoParams: {autoplay: true, muted: true, title: false, byline: false, portrait:false, controls: false, loop: true, dnt: true},
		};
	},
	mounted() {
		this.listTransitionLibrary();
		this.listTenantPlan();
		this.listTenant();
		this.listTag();
	},
	methods: {
		listTransitionLibrary() {
			axios.get("/system/transitionlibrary/list").then((response) => {
				this.transitionLibraryList = response.data;
				this.transitionLibraryAll = this.transitionLibraryList;
			});
		},
		listTag() {
			axios.get("/system/transitionlibrary/tag/list").then((response) => {
				this.tagList = response.data;
			});
		},
		filterLibrary() {
			axios
				.post("/system/transitionlibrary/filter", {
					planFilter: this.planFilter,
					tagFilter: this.tagFilter,
					tenantPlanId: null,
				})
				.then((response) => {
					this.transitionLibraryList = response.data;
				});
		},
		resetFilter() {
			this.planFilter = [];
			this.tagFilter = [];
			this.transitionLibraryList = this.transitionLibraryAll;
		},
		deleteTransitionLibrary(id) {
			if (confirm("Are you sure you want to delete?")) {
				axios.post("/system/transitionlibrary/delete", { id: id }).then(() => {
					this.listTransitionLibrary();
				});
			}
		},
		addTransitionLibrary() {
			if (this.isTargetOne) {
				this.entity.planList = [];
			} else {
				this.entity.targetId = null;
			}
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.entity));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}

			axios.post("/system/transitionlibrary/add", formData).then(() => {
				this.listTransitionLibrary();
				this.listTag();
				this.entity = {
					dataMap: {},
				};
				this.$refs.formAdd.reset();
				this.clearData();
				this.dialogAdd = false;
			});
		},
		editTransitionLibrary() {
			if (this.isTargetOne) {
				this.entityEdit.planList = [];
			} else {
				this.entityEdit.targetId = null;
			}
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.entityEdit));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}

			axios.post("/system/transitionlibrary/edit", formData).then(() => {
				this.listTransitionLibrary();
				this.listTag();
				this.entityEdit = {
					dataMap: {},
					linkToDataList: [],
				};
				this.$refs.formEdit.reset();
				this.clearData();
				this.dialogEdit = false;
			});
		},
		showAdd() {
			this.backgroundTransitionType = "Upload";
			this.entity = {
				dataMap: {},
				linkToDataList: [],
			};
			this.dialogAdd = true;
		},
		showEdit(item) {
			this.entityEdit = { ...item };
			this.isTargetOne = this.entityEdit.targetId ? true : false;
			if (this.entityEdit.dataMap.bannerRotatingVideo) {
				this.bannerRotatingVideoType = "URL";
			} else {
				this.bannerRotatingVideoType = "Upload";
			}
			if (this.entityEdit.backgroundTransition) {
				this.backgroundTransitionType = "URL";
			} else {
				this.backgroundTransitionType = "Upload";
			}
			this.dialogEdit = true;
		},
		closeAdd() {
			this.entity = {
				dataMap: {},
				linkToDataList: [],
			};
			this.dialogAdd = false;
			this.$refs.formAdd.reset();
			this.clearData();
		},
		closeEdit() {
			this.entityEdit = {
				mainStructure: false,
				dataMap: {},
				linkToDataList: [],
			};
			this.dialogEdit = false;
			this.$refs.formEdit.reset();
			this.clearData();
		},
		listTenantPlan() {
			axios.post("/system/tenantplan/list/type", { type: "" }).then((response) => {
				this.tenantPlanList = response.data;
			});
		},
		listTenant() {
			axios.get("/system/tenant/list").then((response) => {
				this.tenantList = response.data;
			});
		},
		onBackgroundUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					if (this.dialogAdd) {
						this.backgroundTransitionTemp = fr.result;
					} else {
						this.editBackgroundTransitionTemp = fr.result;
					}
					this.attachment1 = files[0]; // this is an image file that can be sent to server...
				});
				this.backgroundTransitionFileName = files[0].name + " (" + files[0].size / 1000 + "kB)";
				this.backgroundTransitionName = files[0].name;
			} else {
				this.attachment1 = null;
			}
		},
		openBackgroundDialog() {
			this.$refs.attachment1.click();
		},
		clearData() {
			this.attachment1 = null;
			this.backgroundTransitionFileName = "";
			this.backgroundTransitionImageName = "";
			this.editBackgroundTemp = "";
			this.backgroundTransitionTemp = "";
		},
	},
};
</script>
